import React from "react";
import { useAuth } from "../../../../context/security/AuthProvider";
import {
  useMovement,
  useDispatchTestExit,
  useActionsTestExit,
} from "../../../../context/inventory/TestFormExitProvider";
import "./createHandOut.css";
import { LineTitle } from "../../article";
import StatusEntry from "../../entry/form/StatusEntry";
import Select from "react-select";
import { types } from "../../../../reducers/inventory/handOutReducer";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import {
  FORMAT_DATE_MOMENT,
  LOADED,
  STATUS_EXCUTED,
  STATUS_IN_PROGRESS,
  TYPE_HAND_OUT,
  TYPE_TESTS,
} from "../../../../api/constant";
import Moment from "react-moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faEraser,
  faGasPump,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  formatNumberCOP,
  getTypeMeasure,
} from "../../../../utilities/app.utilities";
import PanelDocumentObservation from "../../../app/PanelDocumentObservations";
import {
  useActionsHandOut,
  useDispatchHandOutForm,
  useHandOut,
} from "../../../../context/inventory/HandOutFormProvider";
import ListInventory from "./ListInventory";
import Items from "../../test/form/tabs/Items";
import { ItemsHandOut } from "./ItemsHandOut";
import { ConsumeItemHandOut } from "./ConsumeItemHandOut";
const CreateHandOut = () => {
  const auth = useAuth();
  const state = useHandOut();
  const dispatch = useDispatchHandOutForm();
  const actions = useActionsHandOut();
  const {
    lookForCode,
    lookedItems,
    movement: {
      item_header_id,
      item_header_name,
      item_header_code,
      status_id,
      created_at,
      movement_id,
      type,
      warehouse_id,
      observation: { observations },
      document: { documents },
    },
    item: {
      description,
      name,
      id,
      created_at_item,
      version,
      type_item,
      is_active,
      reference,
      parent_id,
      to_edit,
    },
    items_consume: { items_consume },
    lotes_item: { lotes_item },
    inventory_item: { items },
  } = state;

  const { item_id, item_code, item_name, item_quantity } = state.item;

  const { warehouses } = auth.user;

  const type_without_kt_for_options = "KT";

  return (
    <section className="container-fluid">
      <LineTitle title={"Salida de producto manual"}>
        <StatusEntry status_id={status_id} />
      </LineTitle>
      <section style={{ marginTop: "12px" }} className="row">
        <div className="form-group flex col-md-1 col-lg-1">
          <label className="control-label">&nbsp;</label>
          <label className="font1 mt-4">ID Salida</label>
        </div>
        <div className="form-group  col-md-1 col-lg-1">
          <label className="control-label">&nbsp;</label>
          <div disabled className="form-control">
            &nbsp;{movement_id}
          </div>
        </div>
        <div className="form-group  col-md-2 col-lg-2">
          <label className="control-label">&nbsp;</label>
          <div disabled className="form-control">
            &nbsp;
            <Moment format={FORMAT_DATE_MOMENT}>{created_at}</Moment>
          </div>
        </div>



        <div className="form-group  col-lg-2">
          <label htmlFor="inputType">Seleccione tipo de salida</label>
          <Select
            value={TYPE_HAND_OUT.filter((w) => w.code === type)}
            placeholder="Tipo de salida"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.code}
            options={TYPE_HAND_OUT.filter((w) => w.code !== type_without_kt_for_options)}
            styles={customStyles}
            isDisabled={status_id === STATUS_EXCUTED || status_id === STATUS_IN_PROGRESS}
            onChange={(e) => 
              dispatch({
                type: types.CHANGE_INPUT_HAND_OUT,
                payload: { name: "type", value: e ? e.code : null },
              })
            }
          />
        </div>

        {/* Select warehouse  */}
        <div className="form-group col-md-3 col-lg-3">
          <label htmlFor="inputType">Seleccione el almacén</label>
          <Select
            value={warehouses.filter((w) => w.id === warehouse_id)}
            placeholder="Almacén"
            getOptionLabel={(option) => option.code + " - " + option.name}
            getOptionValue={(option) => option.id}
            options={warehouses}
            styles={customStyles}
            isDisabled={status_id === STATUS_EXCUTED || status_id === STATUS_IN_PROGRESS}
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_HAND_OUT,
                payload: { name: "warehouse_id", value: e ? e.id : null },
              })
            }
          />
        </div>
        {/* Select warehouse */}


        {!movement_id && (
          <div className="form-group col-md-1 col-lg-1">
            <label className="control-label">&nbsp;</label>
            <div
              onClick={() => actions.createHandOut()}
              className="btn-default"
            >
              <FontAwesomeIcon icon={faPlus} />
              &nbsp;Crear
            </div>
          </div>
        )}

        <div className="row mt-4">

          {/* search articles  */}
          {movement_id && (

            <div className="form-group  col-md-4 col-lg-4">
              <label className="control-label">
                Busqueda artículo por nombre o referencia
              </label>
              <div className="input-to-search">
                <input
                  name="lookForCode"
                  value={
                    item_id
                      ? item_name + " - " + item_code
                      : lookForCode
                  }
                  disabled={status_id === STATUS_EXCUTED}
                  onChange={(e) =>
                    dispatch({
                      type: types.CHANGE_INPUT_ITEMS_FORM,
                      payload: { name: e.target.name, value: e.target.value },
                    })
                  }
                  type="text"
                  className="form-control"
                />
                {/* <FontAwesomeIcon
                  onClick={() =>
                    item_header_id &&
                    !status_id &&
                    dispatch({ type: types.REMOVE_ARTICLE })
                  }
                  className="cursor-pointer"
                  icon={item_header_id && !status_id ? faEraser : faSearch}
                /> */}
              </div>

              {lookedItems.length > 0 && !item_id && (
                <div className="container-items-looked-for flex-column">
                  {lookedItems.map((item) => {
                    return (
                      <label
                        key={item.id}
                        onClick={(e) =>
                          dispatch({
                            type: types.CHANGE_PAYLOAD_ITEMS,
                            payload: {
                              ...state.item,
                              item_id: item.id,
                              item_code: item.code,
                              item_name: item.name,
                              item_presentation: item.type,
                              item_measure_name: item.measure_name,
                            },
                          })
                        }
                      >
                        {item.code} - {item.name} - {item.abreviature}
                      </label>
                    );
                  })}
                </div>
              )}
            </div>

          )}
          {/* search articles  */}
          {status_id === STATUS_IN_PROGRESS &&(
            movement_id && (
              <div className="form-group col-md-1 col-lg-1">
                <label className="control-label">&nbsp;</label>
                <div
                  onClick={() => actions.getLotesByItemHandOut()}
                  className="btn-default"
                  isDisabled={status_id === STATUS_EXCUTED}
                >
                  <FontAwesomeIcon icon={faPlus} />
                  &nbsp;Add
                </div>
              </div>
            )
          )}
          
        </div>
        {movement_id && (
          <div className="col-md-5 col-lg-5">
              <ItemsHandOut items={lotes_item} />

              {status_id === STATUS_IN_PROGRESS &&(
                <div style={{ marginTop: "12px" }} className="flex justify-end">
                {" "}
                <button
                  onClick={() => actions.finishHandOut()}
                  className="btn-default flex"
                >
                  <FontAwesomeIcon
                    className="margin-auto"
                    icon={faCheckCircle}
                  />
                  &nbsp; Finalizar
                </button>
              </div>
              )}
            
          </div>

        )}
        {movement_id && (
          <div className="col-md-7 col-lg-7">
            <ConsumeItemHandOut items={items_consume} />
          </div>

        )}
      </section>


      {movement_id && (
        <PanelDocumentObservation
          documents={documents}
          observations={observations}
          actionNewObservation={actions.addObservationToMovement}
          actionNewFiles={actions.addDocumentsToMovement}
          upload_more={status_id !== STATUS_EXCUTED}
        />
      )}
    </section>
  );
};

export default CreateHandOut;
